export default {
    getCouponId: (item) => {
        return item["coupon_id"]
    },
    getUserCancelName: (item) => {
        return item["user_cancel_name"]
    },
    getUserCancelId: (item) => {
        return item["user_cancel_id"]
    },
    getUserCancelAvatarHost: (item) => {
        return item["user_cancel_avatar_host"]
    },
    getUserCancelAvatarName: (item) => {
        return item["user_cancel_avatar_name"]
    },
    getShopId: (item) => {
        return item["shop_id"]
    },
    getShopName: (item) => {
        return item["shop_name"]
    },
    getShopImage: (item) => {
        if (item["shop_image_host"] === "" || item["shop_image_name"] === "") {
            return null
        }
        return {
            host: item["shop_image_host"],
            name: item["shop_image_name"],
        }
    },
    getSourceId: (item) => {
        return item["source_id"]
    },
    getSourceName: (item) => {
        return item["source_name"]
    },
    getCouponName: (item) => {
        return item["coupon_name"]
    },
    getCouponDescr: (item) => {
        return item["coupon_descr"]
    },
    getCouponLogo: (item) => {
        return item["coupon_logo"]
    },
    getCouponPromocode: (item) => {
        return item["coupon_promocode"]
    },
    getCouponDateStart: (item) => {
        return item["coupon_date_start"]
    },
    getCouponDateEnd: (item) => {
        return item["coupon_date_end"]
    },
    getCouponIsCancel: (item) => {
        return item["coupon_is_cancel"]
    },
    getCouponCanceled: (item) => {
        return item["coupon_canceled"]
    },
    getCouponCancelDescr: (item) => {
        return item["coupon_cancel_descr"]
    },
    getCouponIsPublish: (item) => {
        return item["coupon_is_publish"]
    },
    getActive: (item) => {
        return !item["coupon_delst"]
    },
    getCouponDelst: (item) => {
        return item["coupon_delst"]
    },
    getPosts: (item) => {
        return item["posts"]
    },
}
